module.exports = __webpack_public_path__ + "img/img11@2x.063e1dda.png";